const loggedInPages = [
  'loading',
  'feedback',
  'projects',
  'billing',
  'event-feed',
  'statistics',
  'my-tasks',
  'others-tasks',
  'board',
  'settings-account',
  'api-editor',
  'partner',
  'google-calendar-auth-page'
] as const

const allPages = [
  'login',
  'register',
  'recovery', // password recovery
  'mail-settings',
  'no-users', // standalone version welcome page
  'no-license', // standalone version license warning page
  'company-login',
  'incorrect-shared-board-link',
  'email-change',
  ...loggedInPages
] as const

export type Page = (typeof allPages)[number]
type LoggedInPage = (typeof loggedInPages)[number]

export const pagesWithBackground: Page[] = [
  'projects',
  'board',
  'feedback',
  'statistics',
  'settings-account',
  'partner',
  'my-tasks',
  'others-tasks',
  'event-feed'
]

export const isPage = (s: string): s is Page =>
  !!s && allPages.includes(s as Page)

export const isLoggedInPage = (s: string): s is LoggedInPage =>
  !!s && loggedInPages.includes(s as LoggedInPage)
